import React from 'react';
import { CheckIcon, GiftIcon, ZapIcon } from 'lucide-react';
export function ProductBreakdown() {
  const mainProduct = {
    title: 'Sistema completo Viral Video Machine',
    value: '$197',
    features: ['5 módulos que te llevan de idea a video viral en 60 minutos', 'Funciona para cualquier nicho o nivel de habilidad']
  };
  const includes = [{
    title: 'Plantillas de Flujo de Trabajo IA',
    value: '$97',
    features: ['Prompts de ChatGPT y Pika listos para copiar y pegar', 'Generador de guiones virales para rellenar espacios en blanco']
  }, {
    title: 'Plantillas de Voz e Historia',
    value: '$67',
    features: ['Configuraciones de voz IA preconstruidas y guía de tiempo']
  }, {
    title: 'Lista de Verificación de Publicación Viral',
    value: '$47',
    features: ['Cómo publicar, subtitular y etiquetar para máximo alcance']
  }];
  const bonus = {
    title: 'ChatGPT Personalizado "Viral Reel Creator"',
    value: '$97',
    features: ['Asistente de IA personalizado entrenado con marco de millones de vistas', 'Genera ideas virales, guiones y estrategias de contenido instantáneamente', 'Acceso exclusivo a nuestro GPT optimizado para crear reels que convierten']
  };
  const totalValue = 505;
  const sellingPrice = 17;
  const savings = 488;
  return <section id="pricing" className="w-full px-4 py-16 md:py-20" data-id="element-275">
      <div className="max-w-4xl mx-auto" data-id="element-276">
        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 leading-tight" data-id="element-277">
          Esto es lo que obtienes{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400" data-id="element-278">
            hoy
          </span>
        </h2>

        <div className="bg-gradient-to-br from-purple-600/20 to-pink-600/20 border-2 border-purple-500 rounded-2xl p-6 md:p-8 mb-6" data-id="element-279">
          <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-4" data-id="element-280">
            <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-281">
              {mainProduct.title}
            </h3>
            <span className="text-lg md:text-xl font-bold text-purple-300 whitespace-nowrap" data-id="element-282">
              {mainProduct.value}
            </span>
          </div>
          {mainProduct.features.map((feature, index) => <div key={index} className="flex items-start gap-3 mb-2" data-id="element-283">
              <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-284" />
              <p className="text-sm md:text-base text-gray-200" data-id="element-285">{feature}</p>
            </div>)}
        </div>
        {includes.map((item, index) => <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-4" data-id="element-286">
            <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-3" data-id="element-287">
              <h4 className="text-lg md:text-xl font-bold text-white" data-id="element-288">
                {item.title}
              </h4>
              <span className="text-base md:text-lg font-bold text-purple-400 whitespace-nowrap" data-id="element-289">
                {item.value}
              </span>
            </div>
            {item.features.map((feature, idx) => <div key={idx} className="flex items-start gap-3 mb-2" data-id="element-290">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-291" />
                <p className="text-sm md:text-base text-gray-300" data-id="element-292">{feature}</p>
              </div>)}
          </div>)}
        <div className="bg-gradient-to-br from-yellow-500/20 to-orange-500/20 border-2 border-yellow-500 rounded-2xl p-6 md:p-8 mb-8" data-id="element-293">
          <div className="flex items-start gap-3 mb-4" data-id="element-294">
            <GiftIcon className="w-7 h-7 md:w-8 md:h-8 text-yellow-400 flex-shrink-0" data-id="element-295" />
            <h3 className="text-xl md:text-2xl font-bold text-white leading-tight" data-id="element-296">
              BONO: {bonus.title}
            </h3>
          </div>
          <div className="mb-4" data-id="element-297">
            <span className="text-lg md:text-xl font-bold text-yellow-300" data-id="element-298">
              {bonus.value}
            </span>
          </div>
          {bonus.features.map((feature, index) => <div key={index} className="flex items-start gap-3 mb-2" data-id="element-299">
              <CheckIcon className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-1" data-id="element-300" />
              <p className="text-sm md:text-base text-gray-200" data-id="element-301">{feature}</p>
            </div>)}
        </div>
        <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl p-6 md:p-8 text-center" data-id="element-302">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/795LHwrBwMbPM3zbYc2kFK/VVM_5_BOXES.png" alt="Viral Video Machine IA" className="w-full max-w-md mx-auto rounded-xl shadow-2xl mb-6" data-id="element-303" />
          <p className="text-lg md:text-xl text-purple-100 mb-2" data-id="element-304">
            Valor Total:
          </p>
          <p className="text-3xl md:text-4xl font-bold text-white line-through mb-4" data-id="element-305">
            $505
          </p>
          <p className="text-xl md:text-2xl text-purple-100 mb-2" data-id="element-306">
            Precio de Hoy:
          </p>
          <p className="text-5xl md:text-6xl font-bold text-white mb-6" data-id="element-307">
            Solo $17
          </p>
          <a href="https://www.voicesoffreedomus.com/cart/45295821488314:1" className="block w-full px-6 md:px-8 py-5 bg-white hover:bg-gray-100 text-purple-600 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 mb-4" data-id="element-308">
            <div className="text-lg md:text-xl font-bold leading-tight mb-1" data-id="element-309">
              Obtén Acceso Instantáneo
            </div>
            <div className="text-2xl md:text-3xl font-extrabold leading-tight" data-id="element-310">
              Por Solo $17
            </div>
          </a>
          <p className="text-sm md:text-base text-purple-100 mt-4 flex items-center justify-center gap-2 flex-wrap" data-id="element-311">
            <ZapIcon className="w-4 h-4" data-id="element-312" />
            Acceso Inmediato • Garantía de 30 Días • Pago Único
          </p>
        </div>
      </div>
    </section>;
}